import React from 'react';

import {Evaluation, Maybe} from '../schema';
import IconEmptyStar from '../components/icon/IconEmptyStar';
import IconFullStar from '../components/icon/IconFullStar';
import IconSandClock from '../components/icon/IconSandClock';
import {Link} from "react-router-dom";


type Props = {
  evaluation?: Maybe<Evaluation>
  evaluationUrl?: string
  className?: string
}

export default function AttendeeEvaluationStatus({ evaluation, evaluationUrl, className }: Props) {
  if (!evaluation) {
    return ( <div className={className}><IconEmptyStar className="text-gray-dark"/> No evaluation</div> );
  }

  if (!evaluation.approved) {
    return (
      <div className={className}><IconSandClock className="text-gray-dark"/><> Evaluation </>
        { evaluationUrl ?
          <Link className="text-blue hover:text-blue-hover" to={evaluationUrl}>needs approval</Link>
          :<>needs approval</>
        }
      </div>
    );
  }

  return (
    <div className={className}><IconFullStar className="text-yellow"/><> Evaluation </>
      { evaluationUrl ?
        <Link className="text-blue hover:text-blue-hover" to={evaluationUrl}>{evaluation.rating} / 10</Link>
        : <>{evaluation.rating} / 10</>
      }

    </div>
  );

}
